import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="mt-24 border-t border-white/5 bg-black/40">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="font-mystic text-2xl text-rose-400">鏡花黎明</span>
          </div>
          <div className="font-display font-bold text-lg">{settings.site_name}</div>
          <p className="font-mystic text-sm text-zinc-400 mt-1">{settings.tagline}</p>
        </div>
        <div>
          <div className="text-sm font-semibold text-white mb-3">Explore</div>
          <ul className="space-y-1.5 text-sm text-zinc-400">
            <li><Link to="/posts" className="hover:text-rose-300">TL Games</Link></li>
            <li><Link to="/membership" className="hover:text-rose-300">Membership</Link></li>
            <li><Link to="/about" className="hover:text-rose-300">About</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-white mb-3">Account</div>
          <ul className="space-y-1.5 text-sm text-zinc-400">
            <li><Link to="/login" className="hover:text-rose-300">Login</Link></li>
            <li><Link to="/register" className="hover:text-rose-300">Register</Link></li>
            <li><Link to="/dashboard" className="hover:text-rose-300">Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm font-semibold text-white mb-3">Contact</div>
          <div className="space-y-2">
            <div>
              <a
                href="https://discord.gg/fDK3f3WAWg"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-rose-300 hover:text-rose-200"
                data-testid="footer-discord-link"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor"><path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3l-.197.346a17.99 17.99 0 0 0-5.722 0L10.442 3a19.79 19.79 0 0 0-3.76 1.369C2.96 9.6 2.014 14.682 2.49 19.68a19.93 19.93 0 0 0 5.66 2.79l.495-.79c-.835-.318-1.61-.7-2.33-1.158l.516-.382c4.234 1.926 9.105 1.926 13.286 0l.516.382a14.4 14.4 0 0 1-2.33 1.158l.494.79a19.93 19.93 0 0 0 5.66-2.79c.548-5.85-.78-10.886-3.74-15.31zM8.02 16.43c-1.18 0-2.156-1.058-2.156-2.36 0-1.305.962-2.362 2.156-2.362 1.21 0 2.18 1.07 2.157 2.36 0 1.304-.962 2.362-2.157 2.362zm7.974 0c-1.18 0-2.156-1.058-2.156-2.36 0-1.305.962-2.362 2.156-2.362 1.205 0 2.18 1.07 2.156 2.36 0 1.304-.95 2.362-2.156 2.362z" /></svg>
                Join our Discord
              </a>
            </div>
            <div>
              <a
                href="https://www.facebook.com/KyoukaReimei02"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-sky-400 hover:text-sky-300"
                data-testid="footer-facebook-link"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
                Facebook Founder
              </a>
            </div>
          </div>
          <p className="text-xs text-zinc-600 mt-4">© {new Date().getFullYear()} Kyouka Reimei TL. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
